// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"16":"3ae9271ac2480e13","71":"8a9d08c4bf8849e0","72":"78832b8f1be47139","585":"68ebbb9a5d909464","740":"6cd94fe93512e4b7","820":"ae84d8f6f660976a","832":"deef7c5d7fec3707","925":"57e563f45325eb64","989":"b24c8607ce0e05b7"}[chunkId] + ".js";
};